<script lang="ts">
  import { t } from '../lib/i18n/index.svelte.js'
  import { router } from '../lib/router.svelte.js'
  import Button from '../components/ui/Button.svelte'
</script>

<main class="page state">
  <h1>{t('notfound_title')}</h1>
  <p>{t('notfound_body')}</p>
  <div class="actions">
    <Button variant="primary" onclick={() => router.navigate('/')}>{t('notfound_home')}</Button>
  </div>
</main>

<style>
  .state {
    padding-top: var(--space-6);
    text-align: center;
  }
  h1 {
    margin-bottom: var(--space-2);
    font-size: 22px;
  }
  p {
    color: var(--fg-muted);
  }
  .actions {
    display: flex;
    justify-content: center;
    margin-top: var(--space-4);
  }
</style>
